import React, { useState } from 'react';
import { View, Text } from 'react-native';

import {
  downloadReport,
  DownloadButton
} from '../../elements/ReportDownload';
import SearchableSelect from 'app/src/elements/SearchableSelect';
import { locationOptions } from './filterOptions';

import { cardStyles as styles } from './index';

const AssetsByLocationReport = ({ data }) => {
  const [locationId, setLocationId] = useState(null);

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'assets-by-location-report',
      params: { 'location-id': locationId },
    });
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Assets By Location Report</Text>
      <Text style={styles.label}>Location:</Text>
      <SearchableSelect
        placeholder="Select Location"
        options={[
          { value: 'unassigned', label: 'Unassigned' },
          ...locationOptions(data),
        ]}
        value={locationId}
        onChange={setLocationId}
      />
      <DownloadButton handleDownload={handleDownload} />
    </View>
  );
};

export default AssetsByLocationReport;
